// @flow strict

/**
 * @private
 * @description 节流函数
 * @param {Function} fn 传入需要节流的函数
 * @param {Number} time 节流的间隔，单位为毫秒
 * @return {Function}
 */
export default function throttle(
    fn: () => void,
    time: number
): () => ?TimeoutID {
    let pending = false;
    let timerId: ?TimeoutID = null;

    const later = () => {
        timerId = null;
        if (pending) {
            fn();
            timerId = setTimeout(later, time);
            pending = false;
        }
    };

    return () => {
        pending = true;
        if (!timerId) {
            later();
        }
        return timerId;
    };
}
